/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';

import { ContentBlock, Heading, Text, CardCarousel } from 'sarsaparilla';

import { useUserLocation } from 'shared-ui/geolocation';

import { useHiddenGems } from './api/recommendation-api.queries';
import { CarouselCard } from './CarouselCard/CarouselCard';
import { RecommendationCarouselSkeleton } from './RecommendationCarouselSkeleton';

/**
 * Renders a carousel of "rare finds" campsites.
 * There is no "Explore More" link for this section because it can not be replicated in ui-search
 */
export function HiddenGems() {
    const userLocation = useUserLocation();

    const { data, isPending, isError } = useHiddenGems({
        isEnabled: userLocation !== null,
        latitude: userLocation?.latitude,
        longitude: userLocation?.longitude,
    });

    const cards = React.useMemo(() => {
        if (!data?.results) {
            return [];
        }

        return data?.results?.map((item) => {
            return (
                <CarouselCard
                    key={item.id}
                    item={item}
                    onClick={() => {}}
                    showAvailDates
                    gaTrackingId="782001872081"
                    gaTrackingValue={item.name}
                />
            );
        });
    }, [data?.results]);

    if (isPending) {
        return <RecommendationCarouselSkeleton />;
    }

    // Render nothing is there's nothing to show
    if (isError || !data?.results || data.results.length <= 4) {
        return null;
    }

    return (
        <section>
            <ContentBlock>
                <Heading headingLevel={2} appearance="h4" hasUnderline="left">
                    Hidden Gems
                </Heading>
                <Text className="mb-2">
                    Beautiful, lesser-known spots ready to explore.
                </Text>
            </ContentBlock>

            <CardCarousel
                accessibleName="Hidden Gems"
                gaTrackingId="223428362747"
                overscanPerBreakpoint={{ md: 8 }}
                simulateContentBlock
                peekPerBreakpoint={{ xs: 24, md: 0 }}
            >
                {cards}
            </CardCarousel>
        </section>
    );
}
